"use client";

import { useMemo, type ReactNode } from "react";
import { Provider } from "react-redux";

import { getClientSingletonStore } from "@/store/singleStore";
import type { AppStore } from "@/store";

export function ReduxProvider({ children }: { children: ReactNode }) {
  const store = useMemo<AppStore>(() => getClientSingletonStore(), []);
  return <Provider store={store}>{children}</Provider>;
}
